var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenCircleIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 8,
    fill: "none",
    viewBox: "0 0 9 8",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4,
    r: 4,
    fill: "#47CE75"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenCircleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/green-circle-icon.7b749c835ba53d5460f4c62c5142f9af.svg";